const menuSk = {
    "add_to_cart": "Pridať do košíka",
    "add_to_order": "Pridať k objednávke",
    "already_in_cart": "Už vo vašom košíku",
    "update_order_item": "Aktualizovať objednávku",
    "delete_order_item": "Odstrániť položku",
    "available_categories": "Kategórie ponuky",
    "search_menu_placeholder": "Hľadať v ponuke",
    "guides": {
        "scan_qr": "Naskenujte QR kód na stole telefónom",
        "order": "Objednajte si vybrané položky z telefónu",
        "pay": "Plaťte samostatne alebo naraz z telefónu",
        "accept": "Pokračovať"
    },
    "index_image": "Indexový obrázok",
    "menu_saved": "Menu uložené",
    "new_category": "Nová kategória",
    "menu_editor": "Menu editora",
    "new_item": "Nová položka",
    "menu": "Menu",
    "allergens": "Alergény",
    "generate_qr": "Generovať QR kód",
    "allergen_list": {
        "gluten": "Lepok",
        "crustaceans": "Kôrovce",
        "eggs": "Vajcia",
        "fish": "Ryby",
        "peanuts": "Arašidy",
        "soybeans": "Sójové bôby",
        "milk": "Mlieko",
        "nuts": "Orechy",
        "celery": "Zeler",
        "mustard": "Horčica",
        "sesame": "Sezam",
        "sulphur_dioxide": "Oxid siričitý",
        "lupin": "Lupin",
        "molluscs": "Mäkkýše",
        "vegan": "Vegánsky"
    },
    "add_allergen": "Pridať alergén",
    "auto_translate": "Preklad menu",
    "no_category_name": "V aktuálnom jazyku nie je zadaný žiadny názov kategórie",
    "no_item_name": "V aktuálnom jazyku nie je zadaný žiadny názov položky",
    "category_and_items_language": "Jazyk kategórií a položiek",
    "auto_translate_title": "Automatický preklad ponuky je možné použiť iba na kategórie a položky, ktoré už boli uložené. Odporúča sa vyplniť pôvodný jazyk.",
    "auto_translate_description": "Táto funkcia používa Prekladač Google. Preklady nie sú vždy presné, preto sa oplatí si ich skontrolovať.",
    "translate_from": "Preložiť z",
    "translate_to": "Do týchto jazykov",
    "auto_translate_error_invalid_languages": "Na preklad boli vybraté neplatné jazyky",
    "auto_translate_success": "Menu bolo úspešne preložené",
    "auto_translate_error_permission": "Nemáte povolenie na preklad menu",
    "auto_translate_error_generic": "Počas prekladu sa vyskytla neznáma chyba",
    "auto_translate_feature_not_available": "Automatický preklad menu je k dispozícii iba s predplatným PRO.",
    "change_subscription_plan": "Zmeniť predplatné",
    "menu_headers": "Hlavičky a päty ponuky",
    "menu_header_editor_title": "Hlavičky a päty ponuky sú texty, ktoré sa zobrazujú v hornej a dolnej časti vašej online ponuky a ktoré si môžete ľubovoľne určiť.",
    "menu_header_feature_not_available": "Úprava hlavičky a päty ponuky je k dispozícii iba s predplatným PRO.",
    "menu_header": "Hlavička ponuky",
    "menu_header_placeholder": "Napíšte krátku uvítaciu správu alebo zvýraznite aktuálnu ponuku",
    "menu_footer": "Päta ponuky",
    "menu_footer_placeholder": "Môžete zadať informácie o servisných poplatkoch, alergénoch alebo iné dôležité informácie",
    "menu_header_save_success": "Hlavička a päta ponuky boli úspešne uložené",
    "menu_header_save_error": "Pri ukladaní hlavičky a päty ponuky sa vyskytla chyba",
    "menu_header_permission_error": "Nemáte povolenie na úpravu hlavičky a päty ponuky.",
    "menu_header_generic_error": "Pri načítavaní hlavičky a päty ponuky sa vyskytla neznáma chyba",
    "menu_import": "Import ponuky",
    "import_success": "Posledný import bol úspešne dokončený",
    "import_failed": "Posledný import zlyhal kvôli exportu na strane servera",
    "attached_document": "Priložený dokument",
    "allowed_file_types": "Povolené typy súborov: .doc, .docx, .pdf, .txt, .html",
    "import_language_helpertext": "Jazyk dokumentu",
    "import_options_pro_helpertext": "Možnosti „Deaktivovať“ a „Pridať“ sú dostupné iba s predplatným PRO.",
    "import_option_helpertexts": {
        "replace": "Aktuálne kategórie a položky ponuky budú odstránené a nahradené novovytvorenou ponukou.",
        "deactivate": "Aktuálne kategórie a položky ponuky budú deaktivované a bude pridaná novovygenerovaná ponuka.",
        "add": "Aktuálna ponuka zostane a nové položky ponuky budú pridané za aktuálnu ponuku."
    },
    "import_type": "Typ importu",
    "import_options": {
        "replace": "Nahradiť",
        "deactivate": "Deaktivovať",
        "add": "Pridať"
    },
    "menu_import_tooltip": "Nahrajte súbor s jedálnym lístkom vašej reštaurácie alebo poskytnite odkaz na webovú stránku, ktorá ho obsahuje. V oboch prípadoch sa uistite, že jedálny lístok je v dokumente dostupný v textovej forme, pretože obrázky nedokážeme spracovať. Po spustení importu naša umelá inteligencia automaticky spracuje súbor a vytvorí nový jedálny lístok vo vybranom jazyku. Ak chcete neskôr položky preložiť do viacerých jazykov, použite funkciu „Preklad jedálneho lístka“! Proces importu trvá 5 – 10 minút.",
    "menu_import_replace_warning": "Aktuálne zvolená metóda importu odstráni aktuálne menu a nahradí ho novým menu. Uistite sa, že nahraný súbor má správny formát a obsah, pretože operácia je nevratná! Ak nechcete odstrániť aktuálne menu, vyberte inú metódu importu.",
    "start_import": "Importovať",
    "file_or_url_required": "Vyberte súbor alebo zadajte URL adresu webovej stránky",
    "file_and_url_error": "Môžete poskytnúť iba súbor alebo URL adresu, nie oboje",
    "import_site_url": "URL adresa webovej stránky",
    "import_in_progress": "Prebieha import",
    "import_duration": "Môže to trvať niekoľko minút",
    "listing_manager_info": {
        "summary": "S Mozrestom môžete jednoducho spravovať svoje ponuky a recenzie z jednej platformy. Ušetrite čas, zlepšite si online reputáciu a zvýšte prevádzkovú efektivitu.",
        "bullet_1": "Okamžite aktualizujte svoje záznamy na Tripadvisore, Apple Maps, Google, Facebooku, Quandoo a Bingu jediným kliknutím.",
        "bullet_2": "Dostávajte upozornenia v reálnom čase, keď sa vaše otváracie hodiny a dostupnosť nezhodujú, čím predídete sklamaniu hostí a negatívnym recenziám.",
        "bullet_3": "Rýchlo skontrolujte úplnosť vášho záznamu, aby ste sa uistili, že všetky dôležité údaje – ako sú fotografie, jedálny lístok a otváracie hodiny – sú presné a aktuálne.",
        "setup_button": "Nastavenie Mozrestu",
        "pro_warning": "Táto funkcia vyžaduje predplatné PRO."
    },
    "listing_manager_tabs": {
        "Listing": "Zoznam",
        "ListingAnalytics": "Analýza zoznamov",
        "ReviewsPage": "Recenzie",
        "ReviewAnalytics": "Analýza recenzií",
        "ReplyTemplates": "Šablóny odpovedí",
        "Notifications": "Upozornenia"
    },
    "review_manager_set_title": "Nastaviť správcu recenzií",
    "review_manager_set_description": "Prosím, poskytnite nám nejaké informácie o vašej firme, aby sme mohli vytvoriť základné nastavenia.",
    "confirm_settings": "Potvrdiť nastavenia"
};

export default menuSk;
